<template>
  <div>
    <HomeP />
  </div>
</template>

<script>
import HomeP from "../components/mainComp/HomeP.vue";
export default {
  name: "Main",
  components: {
    HomeP,
  },
  props: ["clockButtonFlags"],
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>